export default __webpack_public_path__ + "static/bmt-e3bf4aeb57ed19240c6ad6977c061c1d.jpeg";